module.exports = __webpack_public_path__ + "static/media/codeMario.d889c6fa.jpg";